import { useCallback } from 'react';
import {
  useActionItem,
  ActionItemOperation as Operation,
} from '@workboard/action-item';

export function use1on1Modal(aiId: string) {
  const { isPermitted } = useActionItem(aiId);
  const canMeet1on1 = isPermitted(Operation.addTo1on1);

  const show1on1Dialog = useCallback(() => {
    window.initMeetingsAddDialog({
      type: '1on1',
      target: {
        targetType: 'action-item',
        apiProperty: 'act_id',
        id: aiId,
      },
    });
  }, [aiId]);

  return [canMeet1on1, show1on1Dialog] as const;
}
